/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import UserlistData from "../UserList/UserlistData";
const UserlistDataPage: React.FC = () => {
  return <UserlistData />;
};

export default UserlistDataPage;
